import React, { useState, useEffect } from 'react';
import { Col, Button, Form, FormGroup, Label, Input } from 'reactstrap';
import { ComponentCard } from '../layout/ComponentCard';

import { Instancia } from '../helpers/axios';
import logger from '../../../services/logger/logger';

export const Descuento = ({
  variant,
  local,
  userSession,
  beginning,
  next,
  previous,
  empresaId,
  descuento,
  setDescuento,
  deployment,
}) => {
  const [listadoDescuentos, setListadoDescuentos] = useState([]);
  const fullName = `${local.nombre} ${local.apellidos}`;
  // Efectos
  useEffect(() => {
    setDescuento({ ...descuento, descuento: '0', tipo: '', id: 0 });
    peticionesApi();
  }, []);

  // Función para las peticiones a API
  const peticionesApi = async () => {
    // Declaramos instancia de axios
    const instance = Instancia(deployment);

    // peticiones a la API
    try {
      // Petición para obtener módulos
      const tiposDescuento = await instance.get(
        `buscarDescuentos?headquarter=${empresaId}&userEmail=${userSession?.profileObj.email}`,
      );
      setListadoDescuentos(tiposDescuento.data);
    } catch (error) {
      // Si se produce un error, lo registramos sin recargar para evitar loop infinito
      logger.error('Error en Descuento:', error);
      sessionStorage.setItem('apiError', error);
    }
  };

  const handleOptionChange = (event) => {
    setDescuento({ ...descuento, descuento: event.target.value });
  };

  const handleDiscountChange = (event) => {
    setDescuento({
      ...descuento,
      id: event.target.value,
      tipo: event.target.id,
    });
  };

  return (
    <Col md="12">
      <ComponentCard
        title={`Descuentos - ${empresaId}`}
        hasButton={false}
        className="clearfix"
        name={fullName}
      >
        <Form className="pt-2">
          <FormGroup className="mb-3">
            <Label>
              <Input
                type="radio"
                id="condescuento"
                name="descuento"
                value="1"
                onChange={handleOptionChange}
              />{' '}
              Aplica descuento
            </Label>
          </FormGroup>
          <FormGroup className="mb-3">
            <Label>
              <Input
                type="radio"
                id="sindescuento"
                name="descuento"
                value="2"
                onChange={handleOptionChange}
              />{' '}
              No aplica descuento
            </Label>
          </FormGroup>
          {descuento.descuento === '1' && (
            <FormGroup className="mb-3">
              <Label for="paymentType">Tipo de descuento</Label>
              <Input
                type="select"
                id="tipoDescuento"
                name="tipoDescuento"
                onChange={handleDiscountChange}
              >
                <option value="0" id=""></option>
                {listadoDescuentos.map((option) => (
                  <option value={option.id} key={option.id} id={option.descripcion}>
                    {option.descripcion}
                  </option>
                ))}
              </Input>
            </FormGroup>
          )}
        </Form>
        <div className="pt-2" style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button onClick={previous}>Atrás</Button>
          <Button onClick={beginning}>
            {variant === 'portal' ? 'Volver a detalles' : 'Volver a la ficha de alumno'}
          </Button>
          <Button
            disabled={
              descuento.descuento === '0' || (descuento.descuento === '1' && descuento.tipo === '')
            }
            onClick={() => next(0)}
          >
            Siguiente
          </Button>
        </div>
      </ComponentCard>
    </Col>
  );
};
